import { normalizeTaskLookupId } from '@erp/shared-utils';

export type GoToTaskIdResult =
  | { kind: 'invalid' }
  | { kind: 'missing'; id: string }
  | { kind: 'found'; id: string };

/**
 * Resolve a pasted task id for the queue jump box. `getTask` is injected so
 * this stays unit-testable without the RPC client.
 */
export async function lookupTaskForGoTo(
  raw: string,
  getTask: (id: string) => Promise<{ id: string } | null>,
): Promise<GoToTaskIdResult> {
  const id = normalizeTaskLookupId(raw);
  if (!id) return { kind: 'invalid' };
  const task = await getTask(id);
  if (!task) return { kind: 'missing', id };
  return { kind: 'found', id };
}
